/* Layout porté par membre/assets/css/membre-search.css (classes `.search-*`).
   Ce fichier ne contient que les overrides nécessaires à la variante React. */

/* Wrapper carte : position absolute pour remplir le panel flex de façon
   fiable (height:100% sur grandchildren de flex est instable cross-browser).
   Équivalent du .gas-vue-map-wrapper de vue-member-map.css qui n'est plus
   enqueued dans la variante React. */
.search-map-panel .gas-vue-map-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

@media screen and (min-width: 901px) {
    .search-page-wrapper {
        height: auto;
        min-height: calc(100svh - 80px);
        overflow-anchor: none;
    }

    .search-split-view {
        flex: 0 0 auto;
        height: clamp(640px, calc(100svh - 250px), 940px);
        min-height: 0;
        max-height: clamp(640px, calc(100svh - 250px), 940px);
        overflow-anchor: none;
    }

    /* Colonne liste un peu plus étroite (~32 % vs 35 %) → carte plus large */
    .search-map-panel {
        flex: 17;
    }

    .search-results-panel {
        flex: 8;
        min-width: 300px;
        max-width: 42%;
    }

    /* 2 thérapeutes par ligne */
    .search-results-panel .results-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: var(--gas-space-s, 8px);
        align-items: stretch;
    }

    .search-results-panel .result-item {
        flex-direction: column;
        align-items: flex-start;
        gap: var(--gas-space-xs, 6px);
        min-width: 0;
        padding: var(--gas-space-s, 8px);
    }

    .search-results-panel .result-image {
        flex: 0 0 auto;
        width: 48px;
        height: 48px;
        align-self: center;
    }

    .search-results-panel .result-details {
        width: 100%;
        text-align: center;
    }

    .search-results-panel .result-details h3 {
        font-size: var(--gas-text-xs, 12px);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .search-results-panel .result-name,
    .search-results-panel .result-address {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .search-results-panel .gas-member-search__result-number {
        margin-inline: auto;
    }
}

/* Entre ~901 et ~1100 px : 2 colonnes serrées — photo un peu plus petite */
@media screen and (min-width: 901px) and (max-width: 1100px) {
    .search-results-panel .result-image {
        width: 40px;
        height: 40px;
    }

    .search-results-panel .result-item {
        padding: 6px;
        gap: 4px;
    }
}

/* ── Suggestions (variante React) ──────────────────────────────────────
   La feuille legacy masque .search-suggestions par défaut et l'affichait
   via un style inline ; en React le rendu est conditionnel, ce
   modificateur remplace l'ancien display:block inline. */
.search-suggestions.gas-member-search__suggestions--open {
    display: block;
}

.gas-member-search__criteria-discovery {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    align-items: center;
    gap: var(--gas-space-s);
    margin-top: var(--gas-space-xs);
    padding: var(--gas-space-xxs) var(--gas-space-s);
    border: var(--gas-border-width) solid var(--gas-color-border);
    border-radius: var(--gas-radius-control);
    background: var(--gas-surface-subtle);
    color: var(--gas-color-text-muted);
    font-size: var(--gas-text-xs);
}

.gas-member-search__criteria-discovery > span {
    font-weight: var(--gas-weight-semi);
    white-space: nowrap;
}

.gas-member-search__criteria-shortcuts button {
    min-height: var(--gas-input-height-sm);
    padding: var(--gas-space-xxs) var(--gas-space-xs);
    border: var(--gas-border-width) solid var(--gas-color-border);
    border-radius: var(--gas-radius-full);
    background: var(--gas-color-surface-card);
    color: var(--gas-color-text);
    cursor: pointer;
    font: inherit;
    font-weight: var(--gas-weight-semi);
}

.gas-member-search__criteria-shortcuts {
    display: flex;
    flex-wrap: nowrap;
    gap: var(--gas-space-xxs);
    min-width: 0;
    overflow-x: auto;
    padding-block: 1px;
    scrollbar-width: thin;
}

.gas-member-search__list-format {
    display: inline-flex;
    align-items: center;
    gap: var(--gas-space-xs);
    margin: var(--gas-space-xs) 0 0;
    color: var(--gas-color-text-muted);
    font-size: var(--gas-text-s);
}

.gas-member-search__list-format a {
    color: var(--gas-color-primary);
    font-weight: var(--gas-weight-semi);
    text-decoration: none;
}

.gas-member-search__list-format a:hover,
.gas-member-search__list-format a:focus-visible {
    text-decoration: underline;
    text-underline-offset: 0.18em;
}

.gas-member-search__criteria-shortcuts button:hover {
    border-color: var(--gas-primary);
    color: var(--gas-primary);
}

.gas-member-search__criteria-shortcuts button:focus-visible,
.gas-member-search__filter-rail-header button:focus-visible {
    outline: var(--gas-border-width) solid var(--gas-primary);
    outline-offset: 2px;
}

/* Champ lieu : conteneur positionné pour ancrer les suggestions */
.gas-member-search__location-field {
    position: relative;
    flex: 1;
    min-width: 0;
}

/* Les options sont de vrais boutons afin d'être utilisables au clavier. */
.option-item {
    display: inline-flex;
    align-items: center;
    gap: var(--gas-space-xs);
    font: inherit;
}

.gas-member-search__option-count {
    display: inline-flex;
    min-width: 21.6px;
    height: 21.6px;
    align-items: center;
    justify-content: center;
    padding-inline: var(--gas-space-xxs);
    border-radius: var(--gas-radius-full);
    background: var(--gas-color-surface-card);
    color: var(--gas-color-text-muted);
    font-size: var(--gas-text-xs);
    font-variant-numeric: tabular-nums;
}

.option-item.selected .gas-member-search__option-count {
    background: color-mix(in srgb, var(--gas-white) 20%, transparent);
    color: var(--gas-white);
}

.gas-member-search__filter-section {
    scroll-margin-top: var(--gas-space-m);
}

.option-item:focus-visible {
    outline: var(--gas-border-width) solid var(--gas-primary);
    outline-offset: 2px;
}

.toggle-advanced-button {
    width: auto;
    min-width: 38px;
    height: auto;
    min-height: var(--gas-input-height);
    padding: var(--gas-space-xs) var(--gas-space-s);
    gap: var(--gas-space-xs);
    font-size: var(--gas-text-s);
    white-space: normal;
    text-align: left;
}

/* ── Capsule Airbnb (solution 2) ─────────────────────────────────────── */

.gas-member-search__capsule-sticky {
    z-index: 140;
}

.gas-member-search__capsule-form {
    gap: var(--gas-space-s);
}

.gas-member-search__capsule-wrap {
    position: relative;
    width: 100%;
    max-width: 720px;
    margin-inline: auto;
}

.gas-member-search__capsule-wrap.is-open {
    max-width: min(720px, 100%);
}

.gas-member-search__capsule {
    display: grid;
    grid-template-columns: minmax(0, 1.1fr) minmax(0, 1.2fr) minmax(0, 1fr) auto;
    align-items: stretch;
    gap: 0;
    border: var(--gas-border-width) solid var(--gas-color-border);
    border-radius: var(--gas-radius-full);
    background: var(--gas-color-surface-card);
    box-shadow: var(--gas-shadow-s);
    overflow: hidden;
}

.gas-member-search__capsule.is-open,
.gas-member-search__capsule.has-filters {
    border-color: var(--gas-neutral-300, var(--gas-color-border));
    box-shadow: var(--gas-shadow-s);
}

.gas-member-search__capsule-seg {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 2px;
    min-width: 0;
    padding: var(--gas-space-s) var(--gas-space-m);
    border: 0;
    border-right: var(--gas-border-width) solid var(--gas-color-border);
    background: transparent;
    color: var(--gas-color-text);
    font: inherit;
    text-align: left;
    cursor: pointer;
    transition: background var(--gas-transition-fast, 0.15s ease);
}

.gas-member-search__capsule-seg:last-of-type {
    border-right: 0;
}

.gas-member-search__capsule-seg:hover,
.gas-member-search__capsule-seg.is-focused {
    background: var(--gas-neutral-100, var(--gas-surface-subtle, #f4f5f7));
}

.gas-member-search__capsule-seg:focus-visible {
    outline: 2px solid var(--gas-primary);
    outline-offset: -2px;
    z-index: 1;
}

.gas-member-search__capsule-seg-label {
    font-size: 10px;
    font-weight: var(--gas-weight-bold);
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: var(--gas-color-text-muted);
}

.gas-member-search__capsule-seg-value {
    overflow: hidden;
    color: var(--gas-color-text-muted);
    font-size: var(--gas-text-s);
    font-weight: var(--gas-weight-semi);
    text-overflow: ellipsis;
    white-space: nowrap;
}

.gas-member-search__capsule-seg.has-value .gas-member-search__capsule-seg-value {
    color: var(--gas-color-text);
}

.gas-member-search__capsule-seg .gas-member-search__filter-count {
    position: absolute;
    /* count sits inline via flex on parent — keep simple */
    margin-top: 2px;
    align-self: flex-start;
}

.gas-member-search__capsule-go {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: var(--gas-space-xxs);
    align-self: center;
    min-width: 44px;
    height: 44px;
    margin: var(--gas-space-xxs);
    padding-inline: var(--gas-space-m);
    border-radius: var(--gas-radius-full);
}

.gas-member-search__capsule-go-icon {
    font-weight: var(--gas-weight-bold);
    line-height: 1;
}

/* Voile : laisse la carte visible à gauche, ferme au clic */
.gas-member-search__config-backdrop {
    position: fixed;
    inset: 0;
    /* Sous topbar sticky (~9800), au-dessus du contenu ; drawer à 9600 */
    z-index: 9550;
    margin: 0;
    padding: 0;
    border: 0;
    background: rgba(17, 24, 39, 0.28);
    cursor: pointer;
}

/* Drawer latéral PC : coquille flex (header + body scroll + footer fixe).
   --gas-member-search-drawer-top = bas de gas-user-topbar / admin-bar. */
.gas-member-search__config-panel,
.gas-member-search__config-panel--drawer {
    position: fixed;
    top: var(--gas-member-search-drawer-top, 0px);
    right: 0;
    bottom: 0;
    left: auto;
    z-index: 9600;
    display: flex;
    flex-direction: column;
    gap: 0;
    width: min(400px, 100vw);
    max-width: 100vw;
    height: calc(100dvh - var(--gas-member-search-drawer-top, 0px));
    max-height: calc(100dvh - var(--gas-member-search-drawer-top, 0px));
    /* Le panel ne scroll pas : seul .config-body scrolle */
    overflow: hidden;
    padding: 0;
    border: 0;
    border-left: var(--gas-border-width) solid var(--gas-neutral-200, var(--gas-color-border));
    border-radius: 0;
    background: var(--gas-color-surface-card, #fff);
    box-shadow: -8px 0 28px rgba(16, 24, 40, 0.12);
    transform: none;
}

.gas-member-search__config-panel-header {
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    justify-content: space-between;
    gap: var(--gas-space-s);
    padding: var(--gas-space-m) var(--gas-space-m) var(--gas-space-s);
}

.gas-member-search__config-body {
    flex: 1 1 auto;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 0 var(--gas-space-m) var(--gas-space-s);
    -webkit-overflow-scrolling: touch;
}

.gas-member-search__config-panel-header h2 {
    margin: 0;
    color: var(--gas-color-text);
    font-size: var(--gas-text-m);
    font-weight: var(--gas-weight-bold);
}

.gas-member-search__config-panel-header-actions {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    gap: var(--gas-space-xs);
}

.gas-member-search__config-close {
    display: inline-flex;
    width: var(--gas-input-height);
    height: var(--gas-input-height);
    align-items: center;
    justify-content: center;
    border: var(--gas-border-width) solid var(--gas-color-border);
    border-radius: var(--gas-radius-full);
    background: var(--gas-color-surface-card);
    color: var(--gas-color-text);
    font-size: 20px;
    line-height: 1;
    cursor: pointer;
}

.gas-member-search__config-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: var(--gas-space-s);
    min-height: 0;
}

.gas-member-search__config-section {
    display: grid;
    gap: var(--gas-space-s);
    align-content: start;
    min-width: 0;
    padding: var(--gas-space-s);
    border: var(--gas-border-width) solid transparent;
    border-radius: var(--gas-radius-m, 8px);
}

.gas-member-search__config-section--prefs {
    grid-column: 1 / -1;
    padding: var(--gas-space-s);
    border: var(--gas-border-width) solid var(--gas-neutral-200, var(--gas-color-border));
    border-radius: var(--gas-radius-m, 8px);
    /* Fond très terne — pas de teinte primaire */
    background: var(--gas-neutral-50, #f7f7f8);
}

.gas-member-search__config-section.is-focused {
    border-color: var(--gas-neutral-300, var(--gas-color-border));
    background: var(--gas-neutral-100, #f0f1f3);
}

.gas-member-search__config-section--prefs.is-focused {
    background: var(--gas-neutral-50, #f7f7f8);
    border-color: var(--gas-neutral-300, var(--gas-color-border));
}

.gas-member-search__config-section h3 {
    margin: 0;
    color: var(--gas-color-text);
    font-size: var(--gas-text-s);
    font-weight: var(--gas-weight-bold);
}

.gas-member-search__config-prefs-head {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: var(--gas-space-xs);
}

.gas-member-search__config-prefs-head h3 {
    margin: 0;
}

/* Raccourcis critères : grille compacte pro (pas une rangée de gros boutons) */
.gas-member-search__config-shortcuts.gas-member-search__criteria-shortcuts {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    min-width: 0;
    overflow: visible;
    padding: 0;
}

.gas-member-search__config-shortcuts.gas-member-search__criteria-shortcuts button {
    min-height: 0;
    padding: 4px 10px;
    border: var(--gas-border-width) solid var(--gas-neutral-200, var(--gas-color-border));
    border-radius: var(--gas-radius-full);
    background: var(--gas-color-surface-card, #fff);
    color: var(--gas-color-text-muted);
    font-size: 11px;
    font-weight: var(--gas-weight-medium, 500);
    line-height: 1.3;
    letter-spacing: 0.01em;
    white-space: nowrap;
    cursor: pointer;
    transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;
}

.gas-member-search__config-shortcuts.gas-member-search__criteria-shortcuts button:hover,
.gas-member-search__config-shortcuts.gas-member-search__criteria-shortcuts button:focus-visible {
    border-color: var(--gas-neutral-400, #9ca3af);
    background: var(--gas-neutral-50, #f7f7f8);
    color: var(--gas-color-text);
    outline: none;
}

.gas-member-search__config-shortcuts.gas-member-search__criteria-shortcuts button.is-active {
    border-color: var(--gas-neutral-400, #9ca3af);
    background: var(--gas-neutral-100, #f0f1f3);
    color: var(--gas-color-text);
    font-weight: var(--gas-weight-semi);
}

.gas-member-search__config-criteria {
    min-width: 0;
}

/* Même grille / chips que l’ancien rail (membre-search.css .available-options) */
.gas-member-search__filter-drawer--in-config {
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-m);
}

.gas-member-search__filter-search-block {
    position: sticky;
    top: 0;
    z-index: 2;
    display: grid;
    gap: var(--gas-space-xxs);
    margin: 0 calc(-1 * var(--gas-space-xxs));
    padding: var(--gas-space-xs);
    border: var(--gas-border-width) solid var(--gas-neutral-200, var(--gas-color-border));
    border-radius: var(--gas-radius-m, 8px);
    /* Fond neutre opaque (évite le « bleu » / transparence moche) */
    background: var(--gas-color-surface-card, #fff);
}

/* Spécialisations : scroll interne si catalogue long (rail-like) */
.gas-member-search__spec-scroll {
    max-height: min(320px, 42vh);
    overflow-x: hidden;
    overflow-y: auto;
    padding-right: var(--gas-space-xxs);
    -webkit-overflow-scrolling: touch;
}

.gas-member-search__filter-drawer--in-config .available-options {
    display: flex;
    flex-wrap: wrap;
    gap: var(--gas-space-xs);
}

.gas-member-search__filter-drawer--in-config .available-options--grouped {
    display: block;
}

.gas-member-search__filter-drawer--in-config .option-group {
    margin-bottom: var(--gas-space-s);
}

.gas-member-search__filter-drawer--in-config .option-group:last-child {
    margin-bottom: 0;
}

.gas-member-search__filter-drawer--in-config .option-group-title {
    margin: 0 0 var(--gas-space-xxs);
    color: var(--gas-neutral-600, var(--gas-color-text-muted));
    font-size: var(--gas-text-xs);
    font-weight: var(--gas-weight-semi);
    letter-spacing: 0.03em;
    text-transform: uppercase;
}

.gas-member-search__filter-drawer--in-config .option-group-items {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

/* Chips spés / options un peu plus compactes (police ↓) */
.gas-member-search__filter-drawer--in-config .option-item {
    padding: 3px 8px;
    font-size: 11px;
    line-height: 1.35;
    font-weight: var(--gas-weight-medium, 500);
}

.gas-member-search__filter-drawer--in-config .option-item .gas-member-search__option-count {
    min-width: 18px;
    height: 18px;
    font-size: 10px;
}

.gas-member-search__natural-search--collapsible {
    padding: var(--gas-space-s) var(--gas-space-m);
}

.gas-member-search__natural-search--collapsible > summary {
    cursor: pointer;
    font-weight: var(--gas-weight-bold);
    color: var(--gas-color-text);
    list-style-position: outside;
}

.gas-member-search__natural-search--collapsible > summary:focus-visible {
    outline: 2px solid var(--gas-primary);
    outline-offset: 2px;
}

.gas-member-search__natural-search-form {
    display: grid;
    gap: var(--gas-space-xs);
    margin-top: var(--gas-space-s);
}

.gas-member-search__config-location {
    width: 100%;
}

.gas-member-search__config-location .gas-member-search__location-field {
    flex: 1;
}

.gas-member-search__radius-block {
    display: grid;
    gap: var(--gas-space-xs);
}

.gas-member-search__radius-title {
    color: var(--gas-color-text);
    font-size: var(--gas-text-xs);
    font-weight: var(--gas-weight-semi);
}

.gas-member-search__radius-options {
    display: flex;
    flex-wrap: wrap;
    gap: var(--gas-space-xxs);
}

.gas-member-search__radius-options button {
    min-height: var(--gas-input-height-sm, 32px);
    padding: var(--gas-space-xxs) var(--gas-space-s);
    border: var(--gas-border-width) solid var(--gas-color-border);
    border-radius: var(--gas-radius-full);
    background: var(--gas-color-surface-card);
    color: var(--gas-color-text);
    font: inherit;
    font-size: var(--gas-text-xs);
    font-weight: var(--gas-weight-semi);
    cursor: pointer;
}

.gas-member-search__radius-options button.is-active,
.gas-member-search__radius-options button[aria-pressed="true"] {
    border-color: var(--gas-neutral-500, #6b7280);
    background: var(--gas-neutral-200, #e5e7eb);
    color: var(--gas-color-text, #111827);
    font-weight: var(--gas-weight-semi);
}

.gas-member-search__field-help {
    margin: 0;
    color: var(--gas-color-text-muted);
    font-size: var(--gas-text-xs);
    line-height: 1.4;
}

.gas-member-search__config-shortcuts {
    flex-wrap: wrap;
}

.gas-member-search__config-footer {
    /* Pied de drawer en flux flex (pas sticky dans un parent scroll) */
    flex: 0 0 auto;
    position: relative;
    z-index: 2;
    display: flex;
    flex-wrap: wrap;
    justify-content: stretch;
    gap: var(--gas-space-s);
    margin: 0;
    padding: var(--gas-space-s) var(--gas-space-m);
    padding-bottom: calc(var(--gas-space-s) + env(safe-area-inset-bottom, 0px));
    border-top: var(--gas-border-width) solid var(--gas-color-border);
    background: var(--gas-color-surface-card, #fff);
    box-shadow: 0 -4px 12px rgba(16, 24, 40, 0.06);
}

.gas-member-search__config-footer .gas-button {
    flex: 1;
}

@media screen and (max-width: 900px) {
    .gas-member-search__capsule {
        grid-template-columns: 1fr 1fr;
        border-radius: var(--gas-radius-l, 16px);
    }

    .gas-member-search__capsule-seg:nth-child(2) {
        border-right: 0;
    }

    .gas-member-search__capsule-seg:nth-child(3) {
        border-top: var(--gas-border-width) solid var(--gas-color-border);
        border-right: var(--gas-border-width) solid var(--gas-color-border);
    }

    .gas-member-search__capsule-go {
        grid-column: 2;
        grid-row: 2;
        width: calc(100% - 2 * var(--gas-space-xxs));
        margin: var(--gas-space-xxs);
        border-radius: var(--gas-radius-m, 8px);
    }

    /* Mobile : bottom sheet — même coquille flex header / body / footer */
    .gas-member-search__config-panel,
    .gas-member-search__config-panel--drawer {
        top: auto;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: min(88svh, 720px);
        max-height: min(88svh, 720px);
        border-left: 0;
        border-top: var(--gas-border-width) solid var(--gas-neutral-200, var(--gas-color-border));
        border-radius: var(--gas-radius-l, 16px) var(--gas-radius-l, 16px) 0 0;
        box-shadow: 0 -8px 28px rgba(16, 24, 40, 0.12);
    }

    .gas-member-search__config-criteria .gas-member-search__natural-search-bar {
        grid-template-columns: 1fr;
    }

    .gas-member-search__spec-scroll {
        max-height: min(220px, 32vh);
    }

    .gas-member-search__filter-search-block {
        background: var(--gas-color-surface-card, #fff);
        box-shadow: 0 1px 0 var(--gas-neutral-200, var(--gas-color-border));
    }
}

.gas-member-search__filter-count {
    display: inline-flex;
    min-width: 21.6px;
    height: 21.6px;
    align-items: center;
    justify-content: center;
    border-radius: var(--gas-radius-full);
    background: var(--gas-primary);
    color: var(--gas-white);
    font-size: var(--gas-text-xs);
}

.toggle-advanced-button.active .gas-member-search__filter-count {
    background: var(--gas-white);
    color: var(--gas-primary);
}

.gas-member-search__active-filters-row {
    display: flex;
    align-items: center;
    gap: var(--gas-space-xs);
    min-width: 0;
}

.gas-member-search__active-filters {
    display: flex;
    flex: 1 1 auto;
    align-items: center;
    gap: var(--gas-space-xs);
    min-width: 0;
    overflow-x: auto;
    padding-block: var(--gas-space-xxs);
    scrollbar-width: thin;
}

.gas-member-search__active-filters button,
.gas-member-search__quick-filters button {
    display: inline-flex;
    flex: 0 0 auto;
    align-items: center;
    gap: var(--gas-space-xs);
    min-height: var(--gas-input-height);
    padding-inline: var(--gas-space-s);
    border: var(--gas-border-width) solid var(--gas-color-border);
    border-radius: var(--gas-radius-full);
    background: var(--gas-color-surface-card);
    color: var(--gas-color-text);
    cursor: pointer;
    font: inherit;
    font-size: var(--gas-text-xs);
}

.gas-member-search__active-filters button:not(.gas-member-search__clear-filters) {
    border-color: var(--gas-primary);
    background: var(--gas-primary-light);
    color: var(--gas-primary-text);
}

.gas-member-search__clear-filters {
    text-decoration: underline;
}

.gas-member-search__reset {
    display: inline-flex;
    flex: 0 0 auto;
    align-items: center;
    gap: var(--gas-space-xs);
    min-height: var(--gas-input-height-sm);
    padding-inline: var(--gas-space-xs);
    color: var(--gas-color-text-muted);
    text-decoration: underline;
    text-underline-offset: var(--gas-space-xxs);
    white-space: nowrap;
}

.gas-member-search__filter-drawer {
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-m);
}

.gas-member-search__natural-search {
    display: grid;
    gap: var(--gas-space-xs);
    padding: var(--gas-space-m);
    border: var(--gas-border-width) solid var(--gas-neutral-200, var(--gas-border-color));
    border-radius: var(--gas-radius-card);
    background: var(--gas-neutral-50, var(--gas-surface-subtle, #f7f7f8));
}

/* Compteur de résultats — capsule + popup */
.gas-member-search__result-count {
    margin: 0;
    color: var(--gas-color-text-muted);
    font-size: var(--gas-text-s);
    font-weight: var(--gas-weight-semi);
    font-variant-numeric: tabular-nums;
    text-align: center;
}

.gas-member-search__result-count strong {
    color: var(--gas-color-text);
    font-weight: var(--gas-weight-bold);
}

.gas-member-search__config-result-count {
    margin: 0;
    padding: var(--gas-space-xxs) var(--gas-space-s);
    border-radius: var(--gas-radius-full);
    background: var(--gas-neutral-100, #f0f1f3);
    color: var(--gas-color-text);
    font-size: var(--gas-text-xs);
    font-weight: var(--gas-weight-semi);
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
}

.gas-member-search__config-section-actions {
    display: flex;
    flex-wrap: wrap;
    gap: var(--gas-space-xs);
    margin-top: var(--gas-space-xxs);
}

.gas-member-search__config-section-actions .gas-button,
.gas-member-search__config-section-actions button {
    font-size: var(--gas-text-xs);
}

.gas-member-search__capsule-go-count {
    display: inline-flex;
    min-width: 1.25em;
    align-items: center;
    justify-content: center;
    margin-left: 2px;
    padding: 0 6px;
    border-radius: var(--gas-radius-full);
    background: color-mix(in srgb, var(--gas-white) 22%, transparent);
    font-size: 11px;
    font-weight: var(--gas-weight-bold);
    font-variant-numeric: tabular-nums;
    line-height: 1.4;
}

.gas-member-search__natural-search > label {
    color: var(--gas-color-text);
    font-weight: var(--gas-weight-bold);
}

.gas-member-search__natural-search > p {
    margin: 0;
    color: var(--gas-color-text-muted);
    font-size: var(--gas-text-xs);
}

.gas-member-search__natural-search-bar {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: var(--gas-space-xs);
}

.gas-member-search__natural-search-bar input {
    min-width: 0;
    min-height: var(--gas-input-height);
    border: var(--gas-border-width) solid var(--gas-input-border);
    border-radius: var(--gas-radius-control);
    padding-inline: var(--gas-space-s);
    background: var(--gas-input-bg);
    color: var(--gas-input-color);
    font: inherit;
}

.gas-member-search__natural-search-error {
    color: var(--gas-danger-dark);
}

.gas-member-search__natural-search-refine {
    justify-self: start;
}

.gas-member-search__filter-search {
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-xs);
    color: var(--gas-color-text);
    font-size: var(--gas-text-s);
    font-weight: var(--gas-weight-semi);
}

.gas-member-search__filter-search input {
    min-height: var(--gas-input-height);
    border: var(--gas-border-width) solid var(--gas-input-border);
    border-radius: var(--gas-radius-control);
    padding-inline: var(--gas-space-s);
    background: var(--gas-input-bg);
    color: var(--gas-input-color);
    font: inherit;
}

.gas-member-search__filter-search-hint,
.gas-member-search__criteria-empty,
.gas-member-search__filter-matches > p {
    margin: 0;
    color: var(--gas-color-text-muted);
    font-size: var(--gas-text-xs);
}

.gas-member-search__filter-matches {
    display: grid;
    gap: var(--gas-space-xs);
    padding: var(--gas-space-s);
    border: var(--gas-border-width) solid var(--gas-neutral-200, var(--gas-color-border));
    border-radius: var(--gas-radius-control);
    background: var(--gas-neutral-50, #f7f7f8);
}

.gas-member-search__filter-matches > strong {
    color: var(--gas-color-text-muted);
    font-size: var(--gas-text-xs);
}

.gas-member-search__filter-matches > div {
    display: grid;
    gap: var(--gas-space-xxs);
}

.gas-member-search__filter-matches button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--gas-space-s);
    width: 100%;
    min-height: var(--gas-input-height);
    padding: var(--gas-space-xs) var(--gas-space-s);
    border: var(--gas-border-width) solid var(--gas-color-border);
    border-radius: var(--gas-radius-control);
    background: var(--gas-color-surface-card);
    color: var(--gas-color-text);
    cursor: pointer;
    font: inherit;
    text-align: left;
}

.gas-member-search__filter-matches button:hover {
    border-color: var(--gas-primary);
}

.gas-member-search__filter-matches button small {
    color: var(--gas-color-text-muted);
    text-align: right;
}

.gas-member-search__quick-filters {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: var(--gas-space-xs);
}

.gas-member-search__quick-filters > span {
    flex-basis: 100%;
    color: var(--gas-color-text);
    font-size: var(--gas-text-s);
    font-weight: var(--gas-weight-semi);
}

.gas-member-search__quick-filters button[aria-pressed="true"] {
    border-color: var(--gas-primary);
    background: var(--gas-primary);
    color: var(--gas-white);
}

.gas-member-search__criteria-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--gas-space-s);
    padding-bottom: var(--gas-space-xs);
    border-bottom: var(--gas-border-width) solid var(--gas-color-border);
    color: var(--gas-color-text-muted);
    font-size: var(--gas-text-xs);
}

.gas-member-search__criteria-toolbar button {
    border: 0;
    background: transparent;
    color: var(--gas-primary);
    cursor: pointer;
    font: inherit;
    font-weight: var(--gas-weight-semi);
    text-decoration: underline;
    text-underline-offset: var(--gas-space-xxs);
}

.gas-member-search__filter-footer {
    display: flex;
    justify-content: space-between;
    gap: var(--gas-space-s);
    width: 100%;
}

.gas-member-search__filter-rail {
    display: flex;
    flex: 0 0 clamp(300px, 24vw, 360px);
    min-width: 0;
    flex-direction: column;
    overflow: hidden;
    border-right: var(--gas-border-width) solid var(--gas-color-border);
    background: var(--gas-color-surface-card);
}

.gas-member-search__filter-rail-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: var(--gas-space-s);
    padding: var(--gas-space-m);
    border-bottom: var(--gas-border-width) solid var(--gas-color-border);
}

.gas-member-search__filter-rail-header h2,
.gas-member-search__filter-rail-header p {
    margin: 0;
}

.gas-member-search__filter-rail-header h2 {
    color: var(--gas-color-text);
    font-size: var(--gas-text-m);
}

.gas-member-search__filter-rail-header p {
    margin-top: var(--gas-space-xxs);
    color: var(--gas-color-text-muted);
    font-size: var(--gas-text-xs);
}

.gas-member-search__filter-rail-header button {
    display: inline-flex;
    min-width: var(--gas-input-height);
    min-height: var(--gas-input-height);
    align-items: center;
    justify-content: center;
    border: var(--gas-border-width) solid var(--gas-color-border);
    border-radius: var(--gas-radius-full);
    background: var(--gas-color-surface-card);
    color: var(--gas-color-text);
    cursor: pointer;
}

.gas-member-search__filter-rail-content {
    min-height: 0;
    overflow-anchor: none;
    scroll-behavior: smooth;
    overflow-y: auto;
    padding: var(--gas-space-m);
}

.gas-member-search__filter-rail .gas-member-search__natural-search-bar {
    grid-template-columns: 1fr;
}

.gas-member-search__match-badges {
    display: flex;
    flex-wrap: wrap;
    gap: var(--gas-space-xxs);
    margin-block: var(--gas-space-xxs);
}

.gas-member-search__match-badges span {
    padding: var(--gas-space-xxs) var(--gas-space-xs);
    border-radius: var(--gas-radius-full);
    background: var(--gas-success-light);
    color: var(--gas-success-dark);
    font-size: var(--gas-text-xs);
    line-height: var(--gas-leading-tight);
}

/* Avatar neutre : aucune représentation genrée implicite quand la photo
   manque ou ne peut pas être chargée. */
.gas-member-search__avatar-fallback {
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    border-radius: var(--gas-radius-full);
    background: var(--gas-neutral-200);
    color: var(--gas-neutral-700);
    font-weight: var(--gas-weight-bold);
    line-height: 1;
}

.result-image .gas-member-search__avatar-fallback {
    border: 2px solid var(--gas-neutral-200);
}

.gas-member-search__result-number {
    display: inline-flex;
    min-width: 24px;
    height: 24px;
    align-items: center;
    justify-content: center;
    margin-bottom: var(--gas-space-xs);
    border-radius: var(--gas-radius-full);
    background: var(--gas-primary);
    color: var(--gas-white);
    font-size: var(--gas-text-xs);
    font-weight: var(--gas-weight-bold);
}

/* ── Markers individuels ───────────────────────────────────────────── */
.gas-member-search__marker-dot {
    display: block;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: var(--gas-primary, #1473e6);
    border: 2px solid #fff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, .35);
    cursor: pointer;
    transition: transform .15s, box-shadow .15s;
}

.gas-member-search__marker-dot:hover {
    transform: scale(1.25);
    box-shadow: 0 2px 6px rgba(0, 0, 0, .4);
}

/* ── Cluster markers ───────────────────────────────────────────────── */
.gas-member-search__cluster {
    display: inline-block;
    border-radius: 50%;
    background: var(--gas-primary, #1473e6);
    color: #fff;
    text-align: center;
    font-weight: 600;
    font-size: 13px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, .25);
    border: 3px solid #fff;
    cursor: pointer;
    user-select: none;
    transition: transform .15s, box-shadow .15s;
}

.gas-member-search__cluster:hover {
    transform: scale(1.08);
    box-shadow: 0 3px 10px rgba(0, 0, 0, .35);
}

/* ── Marker hovered (sync depuis liste résultats) ─────────────────── */
.gas-member-search__marker-dot--hover {
    transform: scale(1.5);
    background: var(--gas-accent, #f59e0b);
    box-shadow: 0 2px 8px rgba(0, 0, 0, .45);
}

/* ── Popup / fiche express (survol + clic) ─────────────────────────── */
.gas-member-search__popup {
    min-width: 224px;
    max-width: 288px;
    font-family: var(--gas-font-family);
    line-height: var(--gas-leading-normal);
}

.gas-member-search__popup--hover {
    min-width: 240px;
    max-width: 304px;
}

.gas-member-search__popup-top {
    display: flex;
    gap: var(--gas-space-s, 8px);
    align-items: flex-start;
}

.gas-member-search__popup-avatar {
    flex: 0 0 48px;
    width: 48px;
    height: 48px;
    border-radius: var(--gas-radius-m, 8px);
    overflow: hidden;
    background: var(--gas-color-surface-muted, #eee);
}

.gas-member-search__popup-avatar img,
.gas-member-search__popup-avatar .gas-member-search__avatar-fallback {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.gas-member-search__popup-avatar .gas-member-search__avatar-fallback {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: var(--gas-text-s, 13px);
    font-weight: 700;
    border-radius: 0;
}

.gas-member-search__popup-meta {
    min-width: 0;
    flex: 1;
}

.gas-member-search__popup-cabinet {
    margin-top: 2px;
    color: var(--gas-primary, #2563eb);
    font-size: var(--gas-text-xs, 12px);
    font-weight: var(--gas-weight-semi, 600);
    line-height: 1.3;
}

.gas-member-search__popup-name {
    color: var(--gas-color-text, #111);
    font-size: var(--gas-text-s, 14px);
    font-weight: var(--gas-weight-bold, 700);
    line-height: 1.25;
}

.gas-member-search__popup-address {
    display: grid;
    gap: 1px;
    margin-top: 4px;
    color: var(--gas-color-text-muted, #555);
    font-size: var(--gas-text-xs, 12px);
    font-style: normal;
    line-height: 1.35;
}

.gas-member-search__popup-chips {
    list-style: none;
    margin: var(--gas-space-xs, 6.4px) 0 0;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
}

.gas-member-search__popup-chips li {
    display: inline-block;
    padding: 2.4px 7.2px;
    border-radius: 999px;
    background: var(--gas-color-surface-muted, #f4f4f5);
    border: 1px solid var(--gas-color-border, #e5e5e5);
    color: var(--gas-color-text, #333);
    font-size: 11px;
    line-height: 1.3;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* CTA profil : battre le `a:hover { color: var(--primary-dark) }` global
   (sinon texte sombre sur fond primary → illisible au survol). */
a.gas-member-search__popup-link,
a.gas-member-search__popup-link:link,
a.gas-member-search__popup-link:visited {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-top: var(--gas-space-s, 8px);
    padding: 6.4px 12px;
    border-radius: var(--gas-radius-s, 5.6px);
    background: var(--gas-primary, #0a4a5c);
    color: #fff;
    font-size: var(--gas-text-xs, 12px);
    font-weight: var(--gas-weight-semi, 600);
    text-decoration: none;
    line-height: 1.3;
    transition: background-color 0.15s ease, box-shadow 0.15s ease;
}

a.gas-member-search__popup-link:hover,
a.gas-member-search__popup-link:focus,
a.gas-member-search__popup-link:focus-visible,
a.gas-member-search__popup-link:active {
    background: var(--gas-primary-dark, #083d4d);
    color: #fff;
    text-decoration: none;
    filter: none;
}

a.gas-member-search__popup-link:focus-visible {
    outline: 2px solid var(--gas-primary, #0a4a5c);
    outline-offset: 2px;
    box-shadow: 0 0 0 3px color-mix(in srgb, var(--gas-primary, #0a4a5c) 28%, transparent);
}

.gas-member-search__popup-hint {
    display: block;
    margin-top: var(--gas-space-xs, 5.6px);
    color: var(--gas-color-text-muted, #666);
    font-size: 11px;
    font-weight: 500;
}

/* Fiche express un peu plus lisible dans le chrome MapLibre */
.gas-geo-map .gas-geo-map__hover-popup .maplibregl-popup-content {
    padding: 8.8px 10.4px;
    max-width: 320px;
}

/* Couche de positionnement calée sur le panneau carte (pas le document). */
.search-map-panel {
    position: relative;
    isolation: isolate;
}

.search-map-panel__overlay {
    position: absolute;
    inset: 0;
    z-index: 50;
    pointer-events: none;
    /* Ne pas laisser la carte MapLibre (canvas) peindre par-dessus. */
}

/* Fiche express : ancrée en haut-gauche DU panneau carte uniquement. */
.gas-member-search__express-card {
    position: absolute;
    top: 12px;
    left: 12px;
    width: min(320px, calc(100% - 24px));
    max-height: calc(100% - 24px);
    overflow: auto;
    padding: 12px 28px 12px 12px;
    border-radius: var(--gas-radius-m, 8px);
    background: var(--gas-color-surface, #fff);
    border: 1px solid var(--gas-color-border, #e5e5e5);
    box-shadow: var(--gas-shadow-l, 0 10px 28px rgba(0, 0, 0, 0.18));
    pointer-events: auto;
}

.gas-member-search__express-card .gas-member-search__popup {
    max-width: none;
    min-width: 0;
}

.gas-member-search__express-card-close {
    position: absolute;
    top: 4px;
    right: 5.6px;
    width: 28px;
    height: 28px;
    border: 0;
    border-radius: 999px;
    background: transparent;
    color: var(--gas-color-text-muted, #666);
    font-size: 20px;
    line-height: 1;
    cursor: pointer;
}

.gas-member-search__express-card-close:hover {
    color: var(--gas-color-text, #111);
    background: var(--gas-color-surface-muted, #f4f4f5);
}

/* ── Result card hover / sélection fiche express ─────────────────── */
.result-item {
    cursor: pointer;
}

.result-item--hover {
    box-shadow: var(--gas-shadow-m, 0 4px 12px rgba(0, 0, 0, .12)) !important;
    border-color: var(--gas-primary-light, #93c5fd) !important;
}

.result-item--express {
    border-color: var(--gas-primary, #2563eb) !important;
    box-shadow: var(--gas-shadow-m, 0 4px 12px rgba(37, 99, 235, .18)) !important;
}

/* ── Marker style "photo_zoom" (photo ronde dès zoom ville ~8) ─────── */
.gas-member-search__marker-photo {
    display: block;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
    border: 2px solid #fff;
    box-shadow: 0 2px 6px rgba(0, 0, 0, .38);
    cursor: pointer;
    background: var(--gas-neutral-200, #e5e7eb);
    transition: transform .15s, box-shadow .15s;
}
.gas-member-search__marker-photo img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}
.gas-member-search__marker-photo .gas-member-search__avatar-fallback {
    font-size: var(--gas-text-xs);
}
.gas-member-search__marker-photo--hover,
.gas-member-search__marker-photo:hover {
    transform: scale(1.18);
    box-shadow: 0 4px 10px rgba(0, 0, 0, .45);
    border-color: var(--gas-primary, #1473e6);
}

/* ── Marker style "numbered" (badge numéroté) ─────────────────────── */
.gas-member-search__marker-number {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: var(--gas-primary, #1473e6);
    color: #fff;
    font-weight: 700;
    font-size: 12px;
    border: 2px solid #fff;
    box-shadow: 0 2px 5px rgba(0, 0, 0, .35);
    cursor: pointer;
    user-select: none;
    transition: transform .15s, background .15s;
}
.gas-member-search__marker-number--hover,
.gas-member-search__marker-number:hover {
    transform: scale(1.2);
    background: var(--gas-accent, #f59e0b);
}

/* ── Densité des cartes résultat ──────────────────────────────────── */
/* compact = 40px photo, padding réduit, 1 ligne adresse max */
.gas-member-search--density-compact .result-item {
    padding: 5px !important;
    gap: 5px !important;
}
.gas-member-search--density-compact .result-image {
    flex: 0 0 40px !important;
    width: 40px !important;
    height: 40px !important;
}
.gas-member-search--density-compact .result-details h3 {
    font-size: var(--gas-text-s, 9px) !important;
    margin: 0 0 1px !important;
    line-height: 1.2 !important;
}
.gas-member-search--density-compact .result-details .result-name {
    font-size: var(--gas-text-xs, 8px) !important;
    margin: 0 !important;
    line-height: 1.2 !important;
}
.gas-member-search--density-compact .result-details .result-address {
    font-size: var(--gas-text-xs, 7.8px) !important;
    margin: 1px 0 0 !important;
    line-height: 1.2 !important;
    color: var(--gas-neutral-600, #4b5563);
}
/* On masque la 2e ligne d'adresse en compact pour gagner de l'espace */
.gas-member-search--density-compact .result-details .result-address:not(.result-address-city) {
    display: none;
}

/* medium = 64px photo (défaut CSS du Vue legacy) — aucune surcharge */

/* large = comme avant (80px photo) */
.gas-member-search--density-large .result-image {
    flex: 0 0 80px !important;
    width: 80px !important;
    height: 80px !important;
}

.gas-member-search__mobile-view-switch {
    display: none;
}

@media screen and (max-width: 900px) {
    .gas-member-search__mobile-view-switch {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: var(--gas-space-xs);
        padding: var(--gas-space-xs);
        background: var(--gas-color-surface-card, var(--gas-card-bg));
        border-block: var(--gas-border-width) solid var(--gas-neutral-200);
        position: sticky;
        top: 0;
        z-index: var(--gas-z-sticky, 30);
    }

    .gas-member-search__mobile-view-switch button {
        min-height: var(--gas-input-height, 40px);
        border: var(--gas-border-width) solid transparent;
        border-radius: var(--gas-radius-control, var(--gas-radius-m));
        background: transparent;
        color: var(--gas-neutral-700);
        font: inherit;
        font-weight: var(--gas-weight-semi);
        cursor: pointer;
    }

    .gas-member-search__mobile-view-switch button.is-active {
        border-color: var(--gas-primary);
        background: var(--gas-primary-light);
        color: var(--gas-primary-text, var(--gas-primary-dark));
    }

    .gas-member-search__mobile-view-switch button:focus-visible {
        outline: 2px solid var(--gas-primary);
        outline-offset: 2px;
    }

    .search-split-view[data-mobile-view="map"] .search-results-panel,
    .search-split-view[data-mobile-view="list"] .search-map-panel {
        display: none;
    }

    .search-split-view[data-mobile-view="list"] .search-results-panel {
        display: block;
        min-height: min(560px, 70svh);
    }
}

@media screen and (max-width: 600px) {
    .gas-member-search__natural-search-bar {
        grid-template-columns: 1fr;
    }

    .search-map-panel {
        height: min(400px, 62svh);
        min-height: 300px;
    }

    .search-bar-sticky {
        position: relative;
    }

    .gas-member-search__capsule-go-label {
        display: none;
    }

    .gas-member-search__filter-footer .gas-button {
        flex: 1;
    }

    .gas-member-search__criteria-discovery > span {
        display: none;
    }

    /* Raccourcis dans le panneau config : toujours visibles */
    .gas-member-search__config-shortcuts {
        display: flex;
    }
}
